import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Tooltip } from '@wartek-id/tooltip'

import { DataIndukVariant, SatpenDistrict, SatpenStats } from '@/apis/types'

import { LinkWithTracker } from '@/components/LinkWithTracker'

import { DATA_INDUK_ROUTE } from '@/configs/constants'

import { ProvinceImage } from './ProvinceImage'
import { TooltipProvince } from './TooltipProvince'
import { VARIANT } from '../../constant'
import { statsToTableArray } from '../../helpers'

export const ProvinceLogoCard = ({
  provinceId = '',
  district,
  image,
  stats,
  index,
  additionalParams,
  prefixPath = DATA_INDUK_ROUTE,
  variant = VARIANT.SATPEN,
}: {
  provinceId?: string
  district: SatpenDistrict
  image: string
  stats: SatpenStats
  index: number
  additionalParams: string
  prefixPath?: string
  variant?: DataIndukVariant
}) => {
  const tables = statsToTableArray(stats, variant)
  const linkWithProvince = `${prefixPath}/${provinceId}/${
    district.kodeWilayah
  }${additionalParams !== '?' ? additionalParams : ''}`
  const linkWithoutProvince = `${prefixPath}/${district.kodeWilayah}${
    additionalParams !== '?' ? additionalParams : ''
  }`

  return (
    <LinkWithTracker
      href={provinceId ? linkWithProvince : linkWithoutProvince}
      tabIndex={0}
      data-index={index}
      className={clsx(
        'province relative z-10 flex cursor-pointer bg-white px-4 py-2 ring-inset ring-blue-400 hover:bg-blue-5 focus:ring-2'
      )}
    >
      <div className="relative flex w-full items-center gap-4">
        <Tooltip
          placement="bottom-start"
          trigger="hover"
          strategy="absolute"
          maxWidth={200}
          delay={500}
          content={
            <TooltipProvince
              name={district.namaWilayahDagri || district.namaWilayah}
              tables={tables}
            />
          }
        >
          <ProvinceImage
            image={image}
            alt={district.namaWilayahDagri || district.namaWilayah}
            level={provinceId ? 'country' : 'district'}
          />
        </Tooltip>
        <Text>{district.namaWilayahDagri || district.namaWilayah}</Text>
      </div>
    </LinkWithTracker>
  )
}
